const statuses = {
  "1": "Incoming",
  "2": "Packing",
  "3": "ReadyForAdmin",
  "4": "OutForDelivery",
  "5": "Delivered",
  "6": "PickupTasks",
};

export default statuses;
